/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';
import { LinearProgress } from '@material-ui/core';

export const Progress = styled(LinearProgress)`
  position: absolute;
  top: -2px;
  left: 0px;
  right: 0px;
  z-index: 10000;
  display: ${(props) => (props.hidden ? 'none' : 'block')};
`;

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const Content = styled.div`
  flex: 1;
`;

export const OmniSearch = styled.div`
  position: absolute;
  pointer-events: none;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  flex: 1;
`;

export const UserProfile = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
